import { lazy } from "react";

// project imports
import { TargetAudience } from "../../../domain/entities/Campaign";
import { RoleLevel } from "../../../domain/entities/Role";
import MainLayout from "../theme/layout/MainLayout";
import Loadable from "../theme/widgets/Loadable";
import { ProtectedRoute } from "./util/ProtectedRoute";

// dashboard routing
const Campaigns = Loadable(
  lazy(() => import("../pages/requestor/campaigns/Campaigns"))
);
const CampaignsStaff = Loadable(
  lazy(() => import("../pages/requestor/campaigns/Campaigns"))
);
const MessagesStaff = Loadable(
  lazy(() => import("../pages/requestor/messages/Messages"))
);
const Messages = Loadable(
  lazy(() => import("../pages/requestor/messages/Messages"))
);
const Documents = Loadable(
  lazy(() => import("../pages/requestor/documents/Documents"))
);
const DocumentsStaff = Loadable(
  lazy(() => import("../pages/requestor/documents-staff/DocumentsStaff"))
);
const Packages = Loadable(
  lazy(() => import("../pages/requestor/packages/Packages"))
);
const RecipientGroups = Loadable(
  lazy(() => import("../pages/requestor/recipient-groups/RecipientGroups"))
);
const SchoolSeats = Loadable(
  lazy(() => import("../pages/enrollment/SchoolSeats"))
);
const ProgramSeats = Loadable(
  lazy(() => import("../pages/enrollment/ProgramSeats"))
);
const ProgramDemand = Loadable(
  lazy(() => import("../pages/enrollment/ProgramDemand"))
);
const ZoneSeats = Loadable(
  lazy(() => import("../pages/enrollment/ZoneSeats"))
);
const ChoiceDashboard = Loadable(
  lazy(() => import("../pages/enrollment/ChoiceDashboard"))
);
const Recipients = Loadable(
  lazy(() => import("../pages/requestor/Recipients"))
);
const SelectRoutingsTable = Loadable(
  lazy(() => import("../pages/requestor/selectRouting/SelectRouting"))
);
const DocumentSignatureFieldsEditor = Loadable(
  lazy(() => import("../pages/requestor/DocumentSignatureFieldsEditor"))
);
const ChatCommunications = Loadable(
  lazy(() => import("../pages/requestor/chat-communication/index"))
);
const StudentHistory = Loadable(
  lazy(() => import("../pages/student-history/index"))
);
const ArchiveDocuments = Loadable(
  lazy(() => import("../pages/requestor/archive-documents/index"))
);
const Dashboard = Loadable(
  lazy(() => import("../pages/dashboard/Default/index"))
);

// ==============================|| MAIN ROUTING ||============================== //

const RequestorRoutes = {
  path: "/",
  element: (
    <ProtectedRoute level={RoleLevel.SignatureRequestor}>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: "campaignsStaff",
      element: <CampaignsStaff targetAudience={TargetAudience.STAFF} />,
    },
    {
      path: "messagesStaff",
      element: <MessagesStaff targetAudience={TargetAudience.STAFF} />,
    },
    {
      path: "campaigns",
      element: <Campaigns targetAudience={TargetAudience.PARENTS} />,
    },
    {
      path: "messages",
      element: <Messages targetAudience={TargetAudience.PARENTS} />,
    },
    { path: "documents", element: <Documents /> },
    { path: "documentsStaff", element: <DocumentsStaff /> },
    { path: "packages", element: <Packages /> },
    { path: "recipientgroups", element: <RecipientGroups /> },
    { path: "schoolSeats", element: <SchoolSeats /> },
    { path: "programSeats", element: <ProgramSeats /> },
    { path: "programDemand", element: <ProgramDemand /> },
    { path: "choiceDashboard", element: <ChoiceDashboard /> },
    { path: "zoneSeats", element: <ZoneSeats /> },
    { path: "selectRoutings", element: <SelectRoutingsTable /> },
    { path: "recipients", element: <Recipients /> },
    { path: "signaturefields", element: <DocumentSignatureFieldsEditor /> },
    { path: "chatCommunications", element: <ChatCommunications /> },
    { path: "studentHistory", element: <StudentHistory /> },
    { path: "archiveDocuments", element: <ArchiveDocuments /> },
    { path: "dashboard", element: <Dashboard /> },
  ],
};

export default RequestorRoutes;
